package libres.resources.strings

import kotlin.String

internal object StringsEn : Strings {
  override val locale: String = "en"

  override val clubmanager: String = "ClubManager"

  override val home: String = "Home"

  override val features: String = "Features"

  override val pricing: String = "Pricing"

  override val downloads: String = "Downloads"

  override val contact: String = "Contact"

  override val learn_more: String = "Learn more"

  override val get_started: String = "Get Started"

  override val hero_tag: String = "Digitalise your club"

  override val hero_title: String = "Spend less time managing.\nMore time on football."

  override val hero_desc: String =
      "Replace spreadsheets, paperwork and scattered tools with one modern platform. From member management to finances and communication, ClubManager helps your entire club stay organised with AI-powered automation."

  override val hero_cta: String = "Create your club now"

  override val email_placeholder: String = "Enter you email address"

  override val tech_title: String = "Modern Foundation\nfor Modern Clubs."

  override val tech_tag: String = "Technology"

  override val tech_ai_title: String = "AI-Powered"

  override val tech_ai_desc: String =
      "Leverage integrated AI to automate repetitive tasks, assist with content creation, and help administrators work more efficiently while staying in control."

  override val tech_customisable_title: String = "Customisable"

  override val tech_customisable_desc: String =
      "Adapt the platform to your club's workflows with configurable fields, settings, and programmable extensions that fit organisations of every size."

  override val tech_offline_title: String = "Offline available"

  override val tech_offline_desc: String =
      "Access important club data instantly and continue working even without an internet connection. No waiting for loading screens, whether at the clubhouse, on the pitch or traveling."

  override val tech_apps_title: String = "Native Apps"

  override val tech_apps_desc: String =
      "Enjoy fast, responsive applications built specifically for Windows, macOS, Android, and iOS for the best possible user experience. On top of a web version that works everywhere."

  override val tech_gdpr_title: String = "GDPR Compliant"

  override val tech_gdpr_desc: String =
      "Designed with privacy in mind. Your members' data is handled securely and in accordance with European GDPR requirements."

  override val features_check_tag: String = "What's included"

  override val features_check_title: String = "Everything in one place."

  override val features_check_calendar: String = "Calendar"

  override val features_check_games: String = "Games"

  override val features_check_trainings: String = "Trainings"

  override val features_check_members: String = "Member management"

  override val features_check_teams: String = "Teams"

  override val features_check_pdfs: String = "Pdf Exports"

  override val features_check_coaches: String = "Coaches"

  override val features_check_functionaries: String = "Functionaries"

  override val features_check_applications: String = "Player applications"

  override val features_check_documents: String = "Document storage"

  override val features_check_newsletters: String = "Newsletters"

  override val features_check_surveys: String = "Surveys"

  override val features_check_fees: String = "Membership fees"

  override val features_check_sponsors: String = "Sponsors"

  override val features_check_payouts: String = "Player payouts"

  override val features_check_invoices: String = "Invoices"

  override val features_check_budgeting: String = "Budgeting"

  override val features_check_permissions: String = "User permissions"

  override val get_in_touch: String = "Get in Touch"

  override val features_check_cta: String = "Let's talk about your club needs."

  override val features_title: String = "Manage every part of your club from a single platform."

  override val features_tag: String = "Features"

  override val features_desc: String =
      "ClubManager brings all your daily operations together. Give your staff the tools they need to organise, communicate, and run the club more efficiently."

  override val features_cta: String = "Create your club"

  override val features_squad_title: String = "Squad"

  override val features_squad_desc: String =
      "Manage players, parents, coaches, and staff in one place. Create teams across all age groups and keep your entire squad structure organised."

  override val features_calendar_title: String = "Calendar"

  override val features_calendar_desc: String =
      "Keep everyone on the same page with one shared calendar for matches, training sessions, and club events. Sync events directly with your favourite calendar apps."

  override val features_club_title: String = "Club"

  override val features_club_desc: String =
      "Manage the administrative side of your club with ease. Handle applications, store important documents, send newsletters, and collect feedback from your members."

  override val features_finance_title: String = "Finances"

  override val features_finance_desc: String =
      "Simplify your club finances. Manage sponsors, automate payments, create invoices, and keep track of your annual budget with complete visibility."

  override val difference_tag: String = "The Difference"

  override val difference_title: String = "A better way to run your club."

  override val difference_other_title: String = "Traditional solutions"

  override val difference_other_browser: String = "Web Browser only"

  override val difference_other_generic: String = "Generic tools"

  override val difference_other_fixed: String = "Fixed workflows"

  override val difference_other_manual: String = "Manual processes"

  override val difference_other_separate: String = "Separate tools"

  override val difference_cm_apps: String = "Native apps with offline access"

  override val difference_cm_football: String = "Built specifically for football"

  override val difference_cm_customisable: String = "Customisable and extendable"

  override val difference_cm_ai: String = "AI-powered automation"

  override val difference_cm_platform: String = "One platform for your entire club"

  override val contact_tag: String = "Contact"

  override val contact_title: String = "Get in touch with us."

  override val email_address: String = "Email address"

  override val clubmanager_email: String = "contact@clubmanager.cc"

  override val helpdesk: String = "Helpdesk"

  override val click_here: String = "Click here"

  override val contact_form_title: String = "Fill this form below"

  override val contact_form_name: String = "Your Name"

  override val contact_form_name_placeholder: String = "Enter your full name"

  override val contact_form_email: String = "Your Email"

  override val contact_form_email_placeholder: String = "Enter your email address"

  override val contact_form_message: String = "Your Message"

  override val contact_form_message_placeholder: String = "How can we help?"

  override val contact_form_submit: String = "Send Message"

  override val copyright: String = "© 2025 ClubManager. All Rights Reserved"

  override val downloads_tag: String = "Download"

  override val downloads_title: String = "Downloads for all Platforms"

  override val downloads_for: LibresFormatDownloadsFor =
      LibresFormatDownloadsFor("Download for %1\$s")

  override val downloads_windows: String = "Windows"

  override val downloads_mac: String = "macOS"

  override val downloads_linux: String = "Linux"

  override val downloads_ios: String = "iOS"

  override val downloads_android: String = "Android"

  override val downloads_browser: String = "Browser version"

  override val downloads_cta: String = "Install now"

  override val downloads_platforms: String = "Available platforms"

  override val faq_tag: String = "FAQs"

  override val faq_title: String = "Frequently Asked Questions"

  override val faq_size: String = "Is ClubManager suitable for small clubs?"

  override val faq_size_answer: String =
      "Yes. Whether you're managing a single youth team or a large club with hundreds of members, ClubManager scales with your organisation. Enable only the features you need and grow over time."

  override val faq_import: String = "Can I import my existing data?"

  override val faq_import_answer: String =
      "Yes. Send us your current club data and we will help you transfer it to ClubManager. Our team takes care of the import so you can start managing your club right away."

  override val faq_secure: String = "Is my club's data secure?"

  override val faq_secure_answer: String =
      "Absolutely. Your data is stored securely and handled in accordance with GDPR. We use modern security practices to protect your club and its members."

  override val faq_devices: String = "Which devices are supported?"

  override val faq_devices_answer: String =
      "ClubManager is available as native apps for Windows, macOS, Android and iOS, as well as through your web browser when needed."

  override val ea_tag: String = "Early Access"

  override val ea_title: String = "Join ClubManager before the public launch."

  override val ea_desc: String =
      "ClubManager is currently in Early Access. Football clubs can already register and start using the platform while we continue adding new features and improvements."

  override val ea_club_name: String = "Your Club"

  override val ea_club_name_placeholder: String = "Enter your club's name"

  override val ea_cta: String = "Request Early Access"

  override val ea_note: String =
      "We'll review your registration and send you your club's access details by email."

  override val ea_future_tag: String = "Why Early Access?"

  override val ea_future_title: String = "Help shape the future of ClubManager"

  override val ea_future_desc: String =
      "As an Early Access member, your club gets access to the platform before the public release. Your feedback helps us improve existing features and prioritise new ones that matter to football clubs."

  override val ea_future_headline: String = "What you'll receive"

  override val ea_future_feature_early_access_title: String = "Early access to the platform"

  override val ea_future_feature_early_access_desc: String =
      "Start managing your club before the official launch."

  override val ea_future_feature_communication_title: String =
      "Direct communication with the development team"

  override val ea_future_feature_communication_desc: String =
      "Share feedback, report issues and suggest new features."

  override val ea_future_feature_updates_title: String = "Regular updates"

  override val ea_future_feature_updates_desc: String =
      "New features and improvements are delivered throughout the Early Access period."

  override val ea_future_feature_support_title: String = "Personal onboarding support"

  override val ea_future_feature_support_desc: String =
      "Get help directly from the team whenever you need it."

  override val ea_faq_early_access: String = "What does Early Access mean?"

  override val ea_faq_early_access_answer: String =
      "ClubManager is fully usable, but we're still expanding the platform with new features and refinements. Early Access members get immediate access while helping shape future development."

  override val ea_faq_access: String = "How do I get access?"

  override val ea_faq_access_answer: String =
      "Register your club using the form above. We'll create your club workspace and send you everything you need to get started."

  override val ea_faq_pricing: String = "Does Early Access cost anything?"

  override val ea_faq_pricing_answer: String =
      "No, Early Access is completely free. We'll continue to offer access to the platform and provide updates throughout the Early Access period and prepare exclusive launch conditions for you."

  override val ea_faq_data: String = "Will my data be kept after the public launch?"

  override val ea_faq_data_answer: String =
      "Yes. Your club, members, and data will continue seamlessly when ClubManager leaves Early Access."

  override val ea_faq_feedback: String = "Can I provide feedback?"

  override val ea_faq_feedback_answer: String =
      "Absolutely. Feedback from Early Access clubs plays an important role in prioritising future features and improvements."

  override val live_demo: String = "Live Demo"

  override val member_admin_tag: String = "Member Management"

  override val member_admin_title: String = "Modern member administration\nthat ends spreadsheets."

  override val member_admin_desc: String =
      "Your members deserve better than error-prone spreadsheets.\nClubManager deduplicates your records, secures access to sensitive data and keeps them current at any time."

  override val member_admin_check_data: String = "Data import & export"

  override val member_admin_check_secure: String = "Role based access"

  override val member_admin_check_unlimited: String = "Unlimited records"

  override val member_admin_demo_cta: String = "See it with your own data"

  override val member_admin_demo_hint: String = "Try adding a new member."

  override val member_admin_one_system_title: String = "All data in one place."

  override val member_admin_one_system_tag: String = "Master data"

  override val member_admin_one_system_desc: String =
      "Keep every member’s information organised in one complete profile. From contact details to documents and player data, everything stays connected and easy to access. No more digging through folders or spreadsheets."

  override val member_admin_one_system_check_applications: String = "Online player applications"

  override val member_admin_one_system_check_export: String = "Export as Excel or printable PDF"

  override val member_admin_one_system_check_documents: String = "Attach documents to any member"

  override val member_admin_connected_tag: String = "Connected club management"

  override val member_admin_connected_title: String = "More than member records."

  override val member_admin_connected_desc: String =
      "Every member is connected to the rest of your club. Use member data directly in squad planning, manage membership fees through finances and keep everything in sync without entering the same information twice."

  override val member_admin_connected_cta: String = "Learn more about squad management"

  override val member_admin_cta_tag: String = "Ready to leave spreadsheets behind?"

  override val member_admin_cta_title: String = "Your members. Your data. One System."

  override val member_admin_cta_desc: String =
      "Manage every member, team and payment from one place.\nSimple, connected and built for football clubs."

  override val member_admin_cta_cta: String = "Create your club"

  override val squad_mgmt_tag: String = "Squad management"

  override val squad_mgmt_title: String = "Build the right squad for every team."

  override val squad_mgmt_desc: String =
      "Plan your club’s rosters with a clear overview of every player and team, every season. ClubManager makes it easy to assign players, balance squads and keep your entire club structure up to date."

  override val squad_mgmt_check_coaches: String = "Coaches & managers"

  override val squad_mgmt_check_age: String = "Age groups"

  override val squad_mgmt_check_matches: String = "Trainings & matches"

  override val squad_mgmt_demo_cta: String = "See this on your own roster"

  override val squad_mgmt_demo_hint: String = "Try clicking on a player."

  override val squad_mgmt_members_tag: String = "One shared database"

  override val squad_mgmt_members_title: String = "Plan with real club data."

  override val squad_mgmt_members_cta: String = "Learn more about member administration"

  override val squad_mgmt_members_desc: String =
      "Your rosters are built directly on your ClubManager member data. Player information doesn't need to be entered twice. Assign an existing member to a team and the rest of the club stays connected automatically."

  override val squad_mgmt_calendar_tag: String = "Calendar"

  override val squad_mgmt_calendar_title: String = "Your roster is just the beginning."

  override val squad_mgmt_calendar_cta: String = "Learn more about the calendar"

  override val squad_mgmt_calendar_desc: String =
      "Once your teams are planned, they're ready to use throughout ClubManager. Connect players to trainings, matches, teams and other club workflows without maintaining separate lists."

  override val squad_mgmt_cta_tag: String = "Built for football clubs"

  override val squad_mgmt_cta_title: String = "Plan your squads. Simplify your club."

  override val squad_mgmt_cta_desc: String =
      "Manage every roster from one connected system and spend less time maintaining spreadsheets and more time running your club."

  override val squad_mgmt_cta_cta: String = "Create your club"

  override val calendar_tag: String = "Club calendar"

  override val calendar_title: String = "One calendar for your entire club."

  override val calendar_desc: String =
      "Keep trainings, matches and club events organized in one shared calendar.\nClubManager gives everyone a clear view of what's happening and keeps your club's schedule in sync."

  override val calendar_check_events: String = "Trainings, games & events"

  override val calendar_check_access: String = "Role based access"

  override val calendar_check_shared: String = "Shared calendar"

  override val calendar_demo_cta: String = "See your club's schedule"

  override val calendar_demo_hint: String = "Try scheduling a training session."

  override val calendar_club_tag: String = "Club overview"

  override val calendar_club_title: String = "See everything that's happening."

  override val calendar_club_desc: String =
      "From weekly training sessions to weekend matches and club events, keep your entire schedule in one place. Filter the calendar to focus on the teams and events that matter to you."

  override val calendar_club_check_types: String = "Multiple event types"

  override val calendar_club_check_snyc: String = "Sync with your private calendar"

  override val calendar_club_check_teams: String = "Team assignments"

  override val calendar_team_tag: String = "Team schedules"

  override val calendar_team_title: String = "Plan the football, not just the dates."

  override val calendar_team_desc: String =
      "Schedule trainings and matches directly within the context of your teams. Coaches can quickly see what's coming up for their teams without losing sight of the bigger picture."

  override val calendar_team_cta: String = "Learn more about squad management"

  override val calendar_cta_tag: String = "More than a calendar"

  override val calendar_cta_title: String = "Give your club one schedule."

  override val calendar_cta_desc: String =
      "Calendar events are part of your wider ClubManager system. Teams, players, coaches and other club data stay connected, so your schedule works together with the rest of your club administration."

  override val calendar_cta_cta: String = "Create your club"

  override val invoicing_tag: String = "Invoicing & finances"

  override val invoicing_title: String = "Club finances, without the paperwork."

  override val invoicing_desc: String =
      "Create invoices, track payments and keep your club’s finances organised in one place. ClubManager connects financial data directly with your members and club administration."

  override val invoicing_check_invoice: String = "Create & manage invoices"

  override val invoicing_check_fees: String = "Membership fees"

  override val invoicing_check_payouts: String = "Player payouts"

  override val invoicing_check_payments: String = "Payment tracking"

  override val invoicing_demo_cta: String = "Issue your first invoice"

  override val invoicing_demo_hint: String = "Try opening an invoice."

  override val invoicing_invoices_tag: String = "Invoicing"

  override val invoicing_invoices_title: String = "Create invoices in seconds."

  override val invoicing_invoices_desc: String =
      "Generate professional invoices directly from your club data. Member or company information, fees and invoice details are already connected, so you don't have to enter the same information over and over again."

  override val invoicing_invoices_check_professional: String = "Professional invoices"

  override val invoicing_invoices_check_pdf: String = "PDF export"

  override val invoicing_invoices_check_status: String = "Payment status"

  override val invoicing_fees_tag: String = "Membership fees"

  override val invoicing_fees_title: String = "Make membership fees effortless."

  override val invoicing_fees_cta: String = "Learn more about member administration"

  override val invoicing_fees_desc: String =
      "Manage your members' fees directly in ClubManager. Define fees, assign them to members and keep track of what has been paid and what is still outstanding."

  override val invoicing_cta_tag: String = "Financial overview"

  override val invoicing_cta_title: String = "Know where your club stands."

  override val invoicing_cta_desc: String =
      "Get a clear picture of your club's financial situation without piecing together information from different spreadsheets and systems."

  override val invoicing_cta_cta: String = "Create your club"
}
